// Accordion by WebSensePro.com
$(function() {
	// (Optional) Active an item if it has the class "is-active"	
	$(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
	
	$(".accordion > .accordion-item").click(function() {
		// Cancel the siblings
		$(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
		// Toggle the item
		$(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
	});
});



window.addEventListener("load", () => {
const slider = document.querySelector('.slider');
const container = slider.querySelector('.slider-container');
const items = container.querySelectorAll('.recommends-box');
const prevBtn = slider.querySelector('.slider-prev');
const nextBtn = slider.querySelector('.slider-next');

let currentIndex = 0;

function showSlide(index) {
  if ($(window).width() > 600) {
  container.style.transform = `translateX(-${index * 50}%)`;
  currentIndex = index;  
  } else {
  container.style.transform = `translateX(-${index * 100}%)`;
  currentIndex = index;
  }
}

function handlePrev() {
  const prevIndex = currentIndex === 0 ? items.length - 1 : currentIndex - 1;
  showSlide(prevIndex);
}

function handleNext() {
  let nextIndex
    if ($(window).width() > 600) {
  nextIndex = currentIndex === items.length - 2 ? 0 : currentIndex + 1;
   
  } else {
   nextIndex = currentIndex === items.length - 1 ? 0 : currentIndex + 1;
  
  }
  showSlide(nextIndex);
}

prevBtn.addEventListener('click', handlePrev);
nextBtn.addEventListener('click', handleNext);

})

